import type {
  ConfigFormat,
  McpClientId,
} from "@arcadeai/ui-kit/mcp-gateway-connect";
import {
  getClientIdsForAuthType,
  resolveMcpClientForAuthType,
} from "@arcadeai/ui-kit/mcp-gateway-connect";
import type { JSX } from "react";
import { ClientConnectChipGrid } from "./client-connect-chip-grid";
import {
  ClientConnectDetailPanel,
  type ConnectGatewayShape,
} from "./client-connect-detail-panel";

const ONBOARDING_LAUNCH_CLIENT_IDS: ReadonlySet<McpClientId> = new Set([
  "cursor",
  "claude_desktop",
  "claude_code",
  "windsurf",
  "chatgpt",
]);

type ClientConnectPickerProps = {
  enginePublicUrl: string;
  gateway: ConnectGatewayShape;
  selectedClientId: McpClientId | undefined;
  onClientChange: (clientId: McpClientId) => void;
  onConfigCopy: (clientId: McpClientId, format: ConfigFormat) => void;
  onDeepLinkClick: (clientId: McpClientId, gatewaySlug: string) => void;
  userId: string | undefined;
};

export function ClientConnectPicker({
  enginePublicUrl,
  gateway,
  selectedClientId,
  onClientChange,
  onConfigCopy,
  onDeepLinkClick,
  userId,
}: ClientConnectPickerProps): JSX.Element {
  const clientIds = getClientIdsForAuthType(gateway.auth_type).filter((id) =>
    ONBOARDING_LAUNCH_CLIENT_IDS.has(id)
  );
  const resolvedSelected = selectedClientId
    ? resolveMcpClientForAuthType(selectedClientId, gateway.auth_type)
    : null;

  return (
    <div className="flex w-full flex-col gap-6">
      <ClientConnectChipGrid
        clientIds={clientIds}
        onSelect={onClientChange}
        selectedId={resolvedSelected}
      />

      {resolvedSelected ? (
        <div className="fade-in slide-in-from-top-1 animate-in fill-mode-both duration-300">
          <ClientConnectDetailPanel
            clientId={resolvedSelected}
            enginePublicUrl={enginePublicUrl}
            gateway={gateway}
            onConfigCopy={onConfigCopy}
            onDeepLinkClick={onDeepLinkClick}
            userId={userId}
          />
        </div>
      ) : null}
    </div>
  );
}
